// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"522": "d5b33fbb92d6879b","757": "9dc32af8180e3ad1",}[chunkId] + ".css"
}